import $ from "jquery";
import plyr from "plyr";

/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(function() {
  const dropdownHideDelay = 500;

  const showDropdown = function($dropdown, $trigger) {
    $dropdown.css({ left: $trigger.offset().left - 15 });
    return $dropdown.fadeIn(100);
  };

  const setupDropdown = function($dropdown, $trigger) {
    let hideDropdown = null;

    $trigger.on('mouseenter', function() {
      showDropdown($dropdown, $trigger);
      if (hideDropdown) {
        return clearTimeout(hideDropdown);
      }
      
    }).on('mouseleave', () => hideDropdown = setTimeout(function() {
      if (!$dropdown.is(':hover')) {
        $dropdown.fadeOut(100);
        return hideDropdown = null;
      }
    }
    , dropdownHideDelay)).on('click', function(e) {
      if (!$dropdown.is(':visible')) {
        showDropdown($dropdown, $trigger);
        if (hideDropdown) {
          clearTimeout(hideDropdown);
        }
      } else {
        $dropdown.fadeOut(100);
        hideDropdown = null;
      }

      return e.stopPropagation();
    });

    $dropdown.on('mouseleave', () => hideDropdown = setTimeout(function() {
      if (!$dropdown.is(':hover')) {
        $dropdown.fadeOut(100);
        return hideDropdown = null;
      }
    }
    , dropdownHideDelay));

    return $dropdown.find('a').on('touchstart', function(e) {
      const $li = $(this).parent();
      if ($li.has('ul').length) {
        e.preventDefault();

        const alreadyActive = $li.hasClass('active');

        // Remove active state from any siblings
        $li.parent().find('> li').removeClass('active');
        $li.addClass('active');

        if (alreadyActive) {
          return window.location = $(this).attr('href');
        }
      }
    });
  };

  const setupMobileDropdown = function($mobileDropdown, $mobileTrigger) {
    $mobileDropdown.find('ul > li > ul').each(function() {
      // Add a dropdown toggle to parent item
      $(this).hide();
      $(this).parent().append('<span class="destinations-mobile__toggle"></span>');
      return $(this).parent().find('> span').click(function() {
        $(this).toggleClass('destinations-mobile__toggle--expanded');
        return $(this).parent().find('> ul').slideToggle(100);
      });
    });

    return $mobileTrigger.click(() => $mobileDropdown.slideToggle(100));
  };

  // Setup destinations dropdown
  if ($('.destinations-dropdown').length) {
    // Duplicate for mobile
    $('.destinations-mobile').append($('.destinations-dropdown').find('> ul').clone());
    setupDropdown($('.destinations-dropdown'), $('.js-destinations-dropdown'));
    setupMobileDropdown($('.destinations-mobile'), $('.js-destinations-mobile'));

    try {
      if (typeof mixpanel !== 'undefined') {
        const mpTrackDestination = node => ({
          "referrer": document.referrer,
          "destination": node.textContent
        });

        mixpanel.track_links('.destinations-dropdown a', "View Destination", mpTrackDestination);
        mixpanel.track_links('.destinations-mobile a', "View Destination", mpTrackDestination);
      }
    } catch (error) {}
  }

  // Setup experiences dropdown
  if ($('.experiences-dropdown').length) {
    // Duplicate for mobile
    $('.experiences-mobile').append($('.experiences-dropdown').find('> ul').clone());
    setupDropdown($('.experiences-dropdown'), $('.js-experiences-dropdown'));

    try {
      if (typeof mixpanel !== 'undefined') {
        const mpTrackExperience = node => ({
          "referrer": document.referrer,
          "experience": node.textContent
        });
        
        mixpanel.track_links('.experiences-dropdown a', "View Experience", mpTrackExperience);
        mixpanel.track_links('.experiences-mobile a', "View Experience", mpTrackExperience);
      }
    } catch (error1) {}
  }

  const historyAvailable = () => !!(window.history && history.pushState);

  //# Destination Page Tabs
  $('a.large-tab').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();

    $('.large-tabs-content > div').each(function() {
      return $(this).hide();
    });
    $('a.large-tab').each(function() {
      return $(this).removeClass('active-tab');
    });

    $($(this).attr('href')).show();
    $(this).addClass('active-tab');

    if (historyAvailable()) {
      history.pushState({ tab: $(this).attr('href') }, '');
    }

    if (typeof mixpanel !== 'undefined') {
      return mixpanel.track('Change Tab', {
        tab: $(this).text()
      });
    }
  });

  if ($('.large-tabs').length && historyAvailable()) {
    // Attempt to restore any old state
    if (history.state && history.state['tab']) {
      $(`a[href=\"${history.state['tab']}\"]`).click();
    }
  }

  //# Weather Information

  const localStorageAvailable = function() {
    const test = 'test';
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }

    return false;
  };

  const updateWeatherTable = function($table, metric) {
    $table.find('td').each(function() {
      if ($(this).attr('data-metric') && metric) {
        $(this).text($(this).data('metric'));
      }
      if ($(this).attr('data-imperial') && !metric) {
        return $(this).text($(this).data('imperial'));
      }
    });

    if (metric) {
      $('.js-weather-metric').removeClass('inactive');
      $('.js-weather-imperial').addClass('inactive');
    } else {
      $('.js-weather-imperial').removeClass('inactive');
      $('.js-weather-metric').addClass('inactive');
    }

  };

  const saveWeatherPreference = function(metric) {
    if (localStorageAvailable()) {
      localStorage.setItem('metric', metric);
    }
  };

  $('.table-weather').each(function() {
    const $table = $(this);
    let choiceMetric = true;

    if (localStorageAvailable()) {
      const preference = localStorage.getItem('metric');
      if (preference !== null) {
        choiceMetric = preference;
      }
    }

    updateWeatherTable($table, choiceMetric);

    $table.find('.js-weather-metric').click(function() {
      choiceMetric = true;
      updateWeatherTable($table, choiceMetric);
      return saveWeatherPreference(choiceMetric);
    });

    return $table.find('.js-weather-imperial').click(function() {
      choiceMetric = false;
      updateWeatherTable($table, choiceMetric);
      return saveWeatherPreference(choiceMetric);
    });
  });

  //# Splash - Video
  return $('body').on('click', '.js-play-splash-video', function() {
    const youtubeId = $(this).data('video-id');

    $(this).hide(); // Hide button
    const $tile = $(this).parent();

    if (!$tile.hasClass('splash-tile-video--playing')) {
      $tile.addClass('splash-tile-video--playing');
      $tile.append(`<div class="js-player" data-type="youtube" data-video-id="${youtubeId}" data-plyr-config='{ "autoplay": true }'></div>`);
      const players = plyr.setup('.js-player');

      return Array.from(players).map((player) =>
        player.on('ended', function(event) {
          $tile.find('.plyr').remove();
          $tile.removeClass('splash-tile-video--playing');
          return $tile.find('a').show();
        }));
    }
  });
});

    // $('.tiled-splash').find('> div').hide()
    // $('.tiled-splash').append("""<div class="splash-video-frame"><div class="js-player" data-type="youtube" data-video-id="#{youtubeId}" data-plyr-config='{ "autoplay": true }'></div></div>""")
    // players = plyr.setup('.js-player')

    // for player in players
    //   player.on('ended', (event) ->
    //     $('.tiled-splash .js-player').remove()
    //     $('.tiled-splash').find('> div').show()
    //   )